var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"om-col",class:( _obj = {}, _obj[("om-col-" + _vm.span)] = _vm.span, _obj[("om-col-offset-" + _vm.offset)] = _vm.offset, _obj ),style:(_vm.style)},[_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20431c14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/jscom/omui/components/col/index.vue
// module id = 6/t/
// module chunks = 76